import { useCallback, useEffect, useState } from 'react'
import { AspenPatientsService, PatientDTO } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const usePatient = (patientId: string) => {
    const [patient, setPatient] = useState<PatientDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    const fetchPatient = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<PatientDTO> = AspenPatientsService.getPatientsPatientIdGet({ patientId })
            const data = await response
            setPatient(data)
        } catch (err) {
            setError('Failed to fetch patient data')
        } finally {
            setLoading(false)
        }
    }, [patientId])

    useEffect(() => {
        fetchPatient()
    }, [fetchPatient])

    return { patient, loading, error, fetchPatient }
}
